import { render, staticRenderFns } from "./EmptyGrid.vue?vue&type=template&id=22faa61c"
import script from "./EmptyGrid.vue?vue&type=script&lang=js"
export * from "./EmptyGrid.vue?vue&type=script&lang=js"
import style0 from "./EmptyGrid.vue?vue&type=style&index=0&id=22faa61c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports